import type { Component } from "vue";
import { defineAsyncComponent } from "vue";

// Per-feature preview mockups, resolved by flag key so a route-level paywall
// (rendered generically by PageFrame) still gets the right illustration without
// PageFrame knowing about individual features.
//
// Async so a feature's preview markup isn't in the bundle for orgs that already
// own the feature and will never see its paywall.
const PREVIEWS: Record<string, Component> = {
  budgetTool: defineAsyncComponent(
    () => import("@/components/Core/Paywall/Previews/BudgetToolPreview.vue"),
  ),
  aiVisibility: defineAsyncComponent(
    () => import("@/components/Core/Paywall/Previews/AiVisibilityPreview.vue"),
  ),
  aiChat: defineAsyncComponent(
    () => import("@/components/Core/Paywall/Previews/AiChatPreview.vue"),
  ),
  crm: defineAsyncComponent(
    () => import("@/components/Core/Paywall/Previews/CrmPreview.vue"),
  ),
};

export function previewForFlag(flag: string): Component | undefined {
  return PREVIEWS[flag];
}
